import { ExchangeState } from "./types";
import { getters } from "./getters";
import { mutations } from "./mutations";
import { actions } from "./actions";

const state: ExchangeState = {
  exchangeConfigUrlCode: null,
  forceDefeat: false,
};

const exchangeModule = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};

export default exchangeModule;
